<mat-drawer-container *ngIf="isLogged==true && isLoaded == true">
  <mat-drawer mode="side" [opened]="sideBarOpen">
    <app-sidebar (sidebarToggle)="sideBarClose()"></app-sidebar>
    <!-- <div _ngcontent-ghq-c126="" class="sidebar-background ng-star-inserted" style="background-image: url('../../../assets/img/sidebar-bg/01.jpg');"></div> -->
  </mat-drawer>

  <mat-drawer-content>
    <app-header (toggleSideBarForMe)="sideBarToggler()" *ngIf="isLogged==true && isLoaded == true"></app-header>

    <router-outlet></router-outlet>

    <app-footer *ngIf="isLogged==true && isLoaded == true"></app-footer>

  </mat-drawer-content>

</mat-drawer-container>



<div *ngIf="isLogged == false || isLoaded == false" class="spinner">
  <mat-spinner [diameter]="50" style="left:22px" mode="indeterminate" *ngIf="isLogged == false || isLoaded == false">
  </mat-spinner>
  <br>
  <h1>Loading...</h1>

</div>